import * as Sentry from '@sentry/browser';
import { config } from '../helpers';
if (config('sentry.dsn')) {
    Sentry.init({
        dsn: config('sentry.dsn'),
        environment: config('app.env'),
    });
}
